<template>
    <div>

        <van-dialog
                v-model="show"
                title="确认微信支付是否完成"
                confirmButtonText="已支付"
                cancelButtonText="取消支付"
                @confirm="ok"
                @cancel="cancel"
                show-cancel-button>

        </van-dialog>

    </div>
</template>

<script>
    export default {
        name: "WxH5Pay",
        data(){

            return{

                orderNo:'', //'201912062310556446',
                show:true,
                id:1,
                channel:1

            }
        },

        created(){

            this.orderNo = this.$route.query.orderNo;

            this.id = this.$route.query.id||1;
            this.channel = this.$route.query.channel||1;


        },
        methods:{

            ok(){

                //1.检查支付状态

                this.$http.post('/GZFPOneMeters/WxH5Checked',{orderNo:this.orderNo}).then((response)=>{
                    sessionStorage.removeItem('show')

                    if(response.data.code==200){

                        //2.已支付跳转到证书页面
                        if(response.data.data) {
                            this.$router.push({path: '/certificate', query: {orderNo: this.orderNo, id: this.id}})
                        }else {
                            this.$toast('订单未支付')

                        }
                    }else {

                        this.$toast(response.data.message)
                    }

                })



            },
            cancel(){

                this.$router.push({path:'/',query:{id:this.id,channel:this.channel}})

            }
        }
    }
</script>

<style scoped>

</style>